import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaDetalleDifProducto from "../components/TablaDetalleDifProducto";
import {diferenciasResources} from "../endpoints";
import CardTotales from "../components/CardTotales";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogExportar from "../components/DialogExportar";
class DetalleProducto extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            producto: "",
            codigo: props.match.params.codigo,
            articulo: '',
            origen: 'detalle_producto',
            tipo: 'detalle_producto',
            datosProducto:{ inv: 0,
                invimp: 0,
                teo: 0,
                teoimp: 0,
                dif: 0,
                difimp: 0},
            severity: '',
            openSnack: false,
            message:'',
            reporte:null,
            params:'',
            open:false
        }
    }

    componentWillMount() {
        this.setState({articulo: this.state.codigo}, this.obtenerDescripcion)
    }

    obtenerDescripcion = () =>{
        diferenciasResources.getDatosProducto(this.state.codigo).then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result !== null){
                this.setState({producto:result.descripcion, datosProducto:result})
            }
        }).catch(error=> {
            console.log(error)
        });
    }
    handleClose = () =>{
        this.setState({open:false})
    }

    enviarDatosReportes =(tipo)=>{
        let params = this.state.codigo
        this.setState({open: true, reporte: tipo, params: params,openSnack:false})
    }
    refrescar =(estado,severity) =>{
        this.setState({ open: false, openSnack: false})
        if (severity){
            this.setState({
                open: false,
                openSnack: true,
                message: estado,
                severity: severity
            })
        }
    }

    render() {
        return(
            <div>
                <Grid container>
                    <Grid item>
                        <Typography variant="h4" gutterBottom>Detalle producto: {this.state.codigo} {this.state.producto}</Typography>
                    </Grid>
                    <Grid item style={{marginLeft:30}}>
                        <Button startIcon={ <SvgIcon>
                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                        </SvgIcon>}
                                variant="contained" color="primary" onClick={() => this.enviarDatosReportes("detalle_conteo")}>
                            Exportar</Button>
                    </Grid>

                </Grid>

                <CardTotales datos={this.state.datosProducto}/>
                <br/>
                <TablaDetalleDifProducto  idProducto={this.state.articulo} tipo={this.state.tipo} origen={this.state.origen}/>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.open? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}
            </div>
        )
    }
}

export default DetalleProducto;